/* add attribute class when editing inputs on summary page */
function summaryEdit() {
    const summaryPanels = document.querySelector(".Summarypage_offers");

    if(summaryPanels) {
        summaryPanels.querySelectorAll(".sk-textbox.sk-attr").forEach((attri) => {
            var listItemParent = attri.parentNode.closest("li");
            
            if(!attri.classList.contains("sk-attr--read")) {
                //listItemParent.style.margin = "0 0 1.4rem 0";
                listItemParent.classList.add("editing");
            } else {
                //listItemParent.style.margin = "unset";
                listItemParent.classList.remove("editing");
            }
        })
    }
}

export { summaryEdit };